/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type {AITransactionResponse} from '../models/AITransactionResponse';
import type {EnsureAiTraceResponse} from '../models/EnsureAiTraceResponse';
import type {RecordAiCorrelationRequest} from '../models/RecordAiCorrelationRequest';
import type {RecordAiSessionRequest} from '../models/RecordAiSessionRequest';
import type {RecordAiTraceRequest} from '../models/RecordAiTraceRequest';
import type {RecordAiTransactionLogRequest} from '../models/RecordAiTransactionLogRequest';
import type {RecordAITransactionRequest} from '../models/RecordAITransactionRequest';
import type {CancelablePromise} from '../core/CancelablePromise';
import type {BaseHttpRequest} from '../core/BaseHttpRequest';
export class AiTransactionService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Records a new AI usage transaction with detail records.
   * @returns AITransactionResponse Created
   * @throws ApiError
   */
  public aiTransactionRecordTransaction({
    requestBody,
  }: {
    requestBody: RecordAITransactionRequest;
  }): CancelablePromise<AITransactionResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/ai-transactions',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
      },
    });
  }
  /**
   * Records a supplemental log entry for an AI session.
   * @returns void
   * @throws ApiError
   */
  public aiTransactionRecordLog({
    requestBody,
  }: {
    requestBody: RecordAiTransactionLogRequest;
  }): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/ai-transactions/log',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
      },
    });
  }
  /**
   * Records an API request correlation entry capturing endpoint, start time, and duration.
   * Called unconditionally for every request that passes through the middleware pipeline.
   * @returns void
   * @throws ApiError
   */
  public aiTransactionRecordCorrelation({
    requestBody,
  }: {
    requestBody: RecordAiCorrelationRequest;
  }): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/ai-transactions/correlation',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
      },
    });
  }
  /**
   * Creates (or retrieves) the AITrace row for the given tracing context, pre-seeding
   * the in-process cache. Called by middleware before the request pipeline starts so all
   * downstream writers link to the same AITrace row.
   * @returns EnsureAiTraceResponse OK
   * @throws ApiError
   */
  public aiTransactionEnsureTrace({
    requestBody,
  }: {
    requestBody: RecordAiTraceRequest;
  }): CancelablePromise<EnsureAiTraceResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/ai-transactions/trace',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
      },
    });
  }
  /**
   * Records a session idempotently. The first call for a given session ID creates the record;
   * subsequent calls are no-ops.
   * @returns void
   * @throws ApiError
   */
  public aiTransactionRecordSession({
    requestBody,
  }: {
    requestBody: RecordAiSessionRequest;
  }): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/ai-transactions/session',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
      },
    });
  }
}
